import * as VTable from '@visactor/vtable';

export * from './tables';
export * from './components';
export { VTable };

export const version = "1.19.7";
